import { v4 as uuidv4 } from 'uuid';
import { RequestConfig } from '@/types/api/response.types';
import axios, { AxiosInstance } from 'axios';
import { onRejected, requestInterceptor, responseInterceptor } from '@/common/api/interceptors';

const baseUrl = (import.meta.env.VITE_APP_API_BASE_URL as string) || '';

export const axiosRequest = (secured = true): AxiosInstance => {
  const config: RequestConfig = {
    baseURL: `${baseUrl}/`,
    requestId: uuidv4(),
    paramsSerializer: {
      indexes: null,
    },
  };

  const accessToken = localStorage.getItem('accessToken');

  if (secured) {
    config.headers = {
      Authorization: `bearer ${accessToken}`,
    };
  }

  const axiosRequest = axios.create(config);

  axiosRequest.interceptors.request.use(requestInterceptor);
  axiosRequest.interceptors.response.use(responseInterceptor, onRejected);

  return axiosRequest;
};
